import { useCallback } from 'react'
import { useToastController } from '@tamagui/toast'
import { useTranslation } from 'react-i18next'
import { isUnauthorizedError } from '@utils/apolloErrors'

/**
 * Centraliza o toast de erro das queries do curso. Os contexts mostram todos o
 * mesmo texto genérico, que pede para recarregar a página — só que `unauthorized`
 * nunca resolve recarregando, e o aluno fica preso no ciclo.
 */
export function useApolloErrorToast() {
  const toast = useToastController()
  const { t } = useTranslation('toast')

  return useCallback(
    (error: unknown, fallbackTitleKey: string) => {
      const unauthorized = isUnauthorizedError(error)

      toast.show(
        t(unauthorized ? 'unauthorizedContent.title' : fallbackTitleKey),
        {
          message: t(
            unauthorized
              ? 'unauthorizedContent.message'
              : 'genericRequestError.message',
          ),
          type: 'error',
        },
      )
    },
    [toast, t],
  )
}
